import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8" }
const _hoisted_3 = { class: "card col-span-2" }
const _hoisted_4 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-5 sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_5 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_6 = ["href"]

import {
		fetchLicenses
	} from './queries'

	// components
	import {
		ArrowDownTrayIcon as ArrowDownTrayIconMini
	} from "@heroicons/vue/20/solid"

	// vue
	import {
		ref,
		onMounted
	} from "vue"

	
	const __default__ = { name: 'LicensingMain' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const loading = ref(true)
	const licenses = ref<any>([])

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	})

	onMounted(() => {
		getLicenses()
	})

	async function getLicenses() {
		try {
			loading.value = true
			licenses.value = await fetchLicenses()
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_card_header_backdrop = _resolveComponent("card-header-backdrop")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full mb-5 flex justify-between" }, [
      _createElementVNode("h1", { class: "text-3xl font-black text-dbBlue" }, " Licensing ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "card-heading" }, " All Licenses ")
          ], -1)),
          _createVNode(_component_card_header_backdrop, { class: "opacity-20" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tw_table, {
            data: licenses.value,
            loading: loading.value,
            placeholder: "No Licenses"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "Contract #",
                prop: "productNumber",
                "class-name": "font-bold text-gray-900"
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "Expiration Date",
                prop: "expirationDate"
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                "class-name": "hidden sm:table-cell",
                "header-class-name": "hidden sm:table-cell",
                header: "Term Years",
                prop: "termYears"
              }),
              _createVNode(_component_tw_table_column, {
                header: "Subtotal",
                condensed: "",
                "header-class-name": "text-right",
                "class-name": "text-right"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_unref(currencyFormatter).format(row.subtotal)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "Download",
                "header-class-name": "sr-only",
                "class-name": "text-right"
              }, {
                default: _withCtx(({row}) => [
                  (row.key)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "link",
                        href: 'https://accounts.claris.com/software/license/' + row.key,
                        target: "_blank"
                      }, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "hidden sm:block" }, "Download", -1)),
                        _createVNode(_unref(ArrowDownTrayIconMini), { class: "w-5 h-5 sm:hidden" })
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading"])
        ])
      ])
    ])
  ]))
}
}

})